import { render, staticRenderFns } from "./MyAdminAccess.vue?vue&type=template&id=c6deca6c&"
import script from "./MyAdminAccess.vue?vue&type=script&lang=js&"
export * from "./MyAdminAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports